import classNames from 'classnames';
import { Trans, useTranslation } from 'next-i18next';

import payment from '../../assets/images/payments.png';
import objectStory from '../../assets/images/object-story.png';
import perfectBuyer from '../../assets/images/perfect-buyer.png';
import styles from './HowSellingWithUsWorks.module.scss';
import { HowItWorksBlock } from './HowItWorksBlock';
import { StartSellingButton } from '../StartSellingButton';
import { StrongBrandContainer } from '../StrongBrandContainer';

export const HowSellingWithUsWorks = ({
  isLoggedIn,
}: {
  isLoggedIn: boolean;
}) => {
  const { t } = useTranslation();

  const blocksContent = [
    {
      id: 1,
      image: objectStory,
      title: <Trans t={t}>{t('seller_register.hiw.story_title')}</Trans>,
      subtitle: <Trans t={t}>{t('seller_register.hiw.story_subtitle')}</Trans>,
    },
    {
      id: 2,
      image: perfectBuyer,
      title: <Trans t={t}>{t('seller_register.hiw.buyer_title')}</Trans>,
      subtitle: <Trans t={t}>{t('seller_register.hiw.buyer_subtitle')}</Trans>,
    },
    {
      id: 3,
      image: payment,
      title: <Trans t={t}>{t('seller_register.hiw.earn_title')}</Trans>,
      subtitle: <Trans t={t}>{t('seller_register.hiw.earn_subtitle')}</Trans>,
    },
  ];

  return (
    <div className={classNames(styles.grayZone, 'u-full-width')}>
      <div className="u-wrapper">
        <section>
          <h2 className="u-typography-h2 u-p-r-xl">
            <Trans
              i18nKey={'seller_register.hiw.title'}
              components={{
                strong: (
                  <StrongBrandContainer className="u-typography-h2-serif" />
                ),
              }}
            />
          </h2>
          <h3 className="u-typography-h3 u-m-t-l u-color-secondary">
            {t('seller_register.hiw.subtitle')}
          </h3>
          {blocksContent.map((block, index) => (
            <HowItWorksBlock
              key={block.id}
              index={index + 1}
              image={block.image}
              title={block.title}
              subtitle={block.subtitle}
            />
          ))}
          <div
            className={classNames(
              styles.hiwStartSelling,
              'tw:flex tw:flex-col tw:items-center'
            )}
          >
            <h3 className="u-typography-h3 tw:items-center tw:text-center">
              {t('seller_register.hiw.cta_caption')}
            </h3>
            <StartSellingButton isLoggedIn={isLoggedIn} />
          </div>
        </section>
      </div>
    </div>
  );
};
